var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{attrs:{"id":_vm.tooltipRef,"variant":"primary"}},[(_vm.user)?_c('span',[_vm._v(_vm._s(_vm.user.email))]):_c('span',[_vm._v("Loading ...")])]),_c('b-tooltip',{ref:"tooltip",attrs:{"target":_vm.tooltipRef},on:{"show":_vm.refreshData}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }